// extracted by mini-css-extract-plugin
export var completionBody = "_m0-2";
export var completionCard = "_m0-0";
export var completionFooter = "_m0-3";
export var completionTitle = "_m0-1";